import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Button , Modal  , Box , Grid , Typography } from "@mui/material";
import PrimaryButton from '../shared/PrimaryButton'
import CustomButton from '../shared/CustomButton'
import LinkButton from "../shared/LinkButton";
const ModalForm = ({
  handleClose,
  title,
  children,
  action,
  Reset,
  open,
  resetFlag = true,
  touched
}) => {

    const style = {
        display: "flex",
        flexDirection: "column",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        height: "600px",
        width: "544px",
        bgcolor: "#F8FAFB",
        border: "none",
        borderRadius:"6px"
      };


  return (
<Modal
    open={open}
    onClose={handleClose}
    
>
   
      <Box sx={style}>
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          sx={{
            height: "64px",
            p: "15px",
            backgroundColor: "#050D2E",
            borderRadius:"6px 6px 0 0"
          }}
        >
          <Grid item>
            <Typography
              sx={{ color: "#ffffff", fontSize: "1.25rem", fontWeight: 550 }}
            >
            {title}
            </Typography>
          </Grid>
          <Grid item>
            <CloseIcon
              sx={{ color: "#ffffff", cursor: "pointer" }}
              onClick={handleClose}
            />
          </Grid>
        </Grid>
        <Grid
          container
          sx={{
            overflow: "auto",
            marginTop: "initial",
            width: "initial",
            marginLeft: "initial",
            position: "relative",
          }}
        >
          <Grid item flexGrow={1}>
            <Box sx={{ padding: "1.5rem 1.5rem 1.5rem 1.5rem"}}>
             {children}
            </Box>
             <Box 
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            padding="1rem"
            borderTop="1px solid #DBDEE6"
            >
                  <div>
            {resetFlag && (
              <LinkButton
              color="#000"
                onClick={() => {
                  Reset();
                }}>
                    Reset
            </LinkButton>
              
            )}
          </div>
          <Box
          display="flex"
          gap={2}
          >
            <div>
            <PrimaryButton onClick={handleClose}>Cancel</PrimaryButton>
             
            </div>
            <div>
            <CustomButton text="Add Customer"  type="update" action={() => action()}  disabled={!touched}/>

            </div>
          </Box>

            </Box> 
          </Grid>
        </Grid>
      </Box>
   
  </Modal>



   
  );
};

export default ModalForm;
